export * from './add-new-task/add-new-task.component';
export * from './inplace-edit/inplace-edit.component';
